export default "__VITE_ASSET__BAoUIUcZ__"